import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const sentenceCaseToCamelCase = (sentence: string): string => {
	return sentence
		.toLowerCase()
		.split(' ')
		.map((word, index) => 
			index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
		)
		.join('');
};

export const formatStepName = (camelCase: string): string => {
	const formatted = camelCase
		.replace(/([A-Z])/g, ' $1') // Add space before capital letters
		.replace(/^./, str => str.toLowerCase()) // Capitalize first letter
		.trim();

	return formatted?.[0] ? formatted?.[0].toUpperCase() + formatted.slice(1) : "";
};

export const formatJsonArray = (jsonString: string | null | undefined | unknown): string => {
	if (!jsonString) return "";
	// Handle case where value is not a string (e.g., already parsed object/array)
	if (typeof jsonString !== 'string') {
		if (Array.isArray(jsonString)) {
			return (jsonString as unknown as string[]).join(", ");
		}
		return "";
	}
	try {
		const array = JSON.parse(jsonString) as string[];
		if (Array.isArray(array)) {
			return array.join(", ");
		}
		return "";
	} catch {
		return "";
	}
}

export function slugify(str: string): string {
	return str
		.toLowerCase()
		.replace(/&/g, '')
		.replace(/\s+/g, '-')
		.replace(/[^\w-]+/g, '')
}

export const formatDuration = (seconds: number): string => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const secs = seconds % 60;

	if (hours > 0) {
		return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
	}
	return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};